import React, { useState,useContext } from 'react'
import { useForm } from "react-hook-form";
import GameContext from '../context/game/GameContext'
import { useNavigate } from "react-router-dom"

function SignUp(props) {
    const [showPassword, setshowPassword] = useState(false)
    const [showConfirmPassword, setshowConfirmPassword] = useState(false)
    let navigate = useNavigate()
    const host = "https://sudoku-backend.netlify.app/.netlify/functions"
    const { register, handleSubmit, watch, formState: { errors } } = useForm({ mode: "all" });
    const context = useContext(GameContext)
    const { getuser } = context
    const onSubmit = async (data) => {
        const response = await fetch(`${host}/api/auth/createUser`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name: data.name, email: data.username, password: data.password })
        });
        const json = await response.json()
        if (json.Status) {
            localStorage.setItem('token', json.authtoken)
            getuser()
            navigate('/')
            // props.showAlert("SignUp Sucessfull", "Succes")
        }
        else {
            // props.showAlert("Invalid credentials", "danger")
        }
    }
    
    return (
        <div className='my-12 pb-32 flex justify-center items-center overflow-y-hidden'>
            <div className='lg:w-1/3 bg-red-100 rounded-lg shadow-xl'>
                <form className='shadow rounded w-full p-7' onSubmit={handleSubmit(onSubmit)}>
                    <p className="focus:outline-none text-2xl font-extrabold leading-6 text-gray-800">Signup to your account</p>
                    <span className=''>
                        < label htmlFor="name" className="text-sm font-medium leading-none text-gray-800" >Name</label>
                        <input
                            id="name"
                            type="text"
                            className=" border-2 border-red-800 rounded  text-xs font-medium leading-none text-gray-800 py-3 w-full pl-3 mt-2"
                            {...register("name",
                                {
                                    required: "Name is a required field",
                                    pattern:
                                    {
                                        value: new RegExp("[A-Za-z/s]{3,}"),
                                        message: "Name must be at least 3 characters long"
                                    },
                                },)} />

                        {errors["name"] && <span className="inline-block w-full text-red-600 text-xs ml-1">{errors["name"].message}</span>}
                    </span>
                    <span className=''>
                        < label htmlFor="username" className="text-sm font-medium leading-none text-gray-800" >Email</label>
                        <input
                            id="username"
                            type="email"
                            className=" border-2 border-red-800 rounded  text-xs font-medium leading-none text-gray-800 py-3 w-full pl-3 mt-2"
                            {...register("username",
                                {
                                    required: "Please enter a valid username",
                                    pattern:
                                    {
                                        value: new RegExp("[\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$"),
                                        message: "Please enter a valid email address"
                                    },
                                },)} />

                        {errors["username"] && <span className="inline-block w-full text-red-600 text-xs ml-1">{errors["username"].message}</span>}
                    </span>
                    <span className='w-full'>
                        <label htmlFor="password" className="text-sm font-medium leading-none text-gray-800" >Password</label>
                        <div className='relative flex items-center justify-center'>
                            <input
                                id="password"
                                type={showPassword ? "text" : "password"}
                                className=" border-2 border-red-800 rounded  text-xs font-medium leading-none text-gray-800 py-3 w-full pl-3 mt-2"
                                {...register("password",
                                    {
                                        required: "Please enter a valid passowrd",
                                    },)} />
                            <div className="absolute right-0 mt-2 mr-3 cursor-pointer">
                                <img src="https://tuk-cdn.s3.amazonaws.com/can-uploader/sign_in-svg5.svg" alt="viewport" onClick={() => { showPassword ? setshowPassword(false) : setshowPassword(true) }} />
                            </div>
                        </div>

                        {errors["password"] && <span className="inline-block w-full text-red-600 text-xs ml-1">{errors["password"].message}</span>}
                    </span>
                    <span className='w-full'>
                        < label htmlFor="confirmPassword" className="text-sm font-medium leading-none text-gray-800" >Confirm Password</label>
                        <div className='relative flex items-center justify-center'>
                            <input
                                id="confirmPassword"
                                type={showConfirmPassword ? "text" : "password"}
                                className=" border-2 border-red-800 rounded  text-xs font-medium leading-none text-gray-800 py-3 w-full pl-3 mt-2"
                                {...register("confirmPassword",
                                    {
                                        required: "Password cannot be blank",
                                        validate: (val) => {
                                            if (watch('password') !== val) {
                                                return "Your passwords do no match";
                                            }
                                        },
                                    },)} />
                            <div className="absolute right-0 mt-2 mr-3 cursor-pointer">
                                <img src="https://tuk-cdn.s3.amazonaws.com/can-uploader/sign_in-svg5.svg" alt="viewport" onClick={() => { showConfirmPassword ? setshowConfirmPassword(false) : setshowConfirmPassword(true) }} />
                            </div>
                        </div>

                        {errors["confirmPassword"] && <span className="inline-block w-full text-red-600 text-xs ml-1">{errors["confirmPassword"].message}</span>}
                    </span>
                    <div className="mt-8">
                        <input className="focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700 text-sm font-semibold leading-none text-white focus:outline-none bg-indigo-700 border rounded hover:bg-indigo-600 py-4 w-full" type="submit" value="Create my account" />
                    </div>
                </form>
            </div>
        </div>
    )
}
export default SignUp
